import { render, staticRenderFns } from "./BusinessMemberDocuments.vue?vue&type=template&id=a45ff5a2"
import script from "./BusinessMemberDocuments.vue?vue&type=script&lang=js"
export * from "./BusinessMemberDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports